export default __webpack_public_path__ + "static/media/dish2.d39a500e.jpg";